import { TFunction } from 'i18next'

import { ContractStatus, UserProfileData } from '../redux/account/user'
import { ContractType } from '../redux/user'

import { createTFunction } from './helpers'

export const getSubscriptionDesc = (contracts: UserProfileData['accounting']['contracts'], t: TFunction) => {
  const primaryContract = contracts === undefined ? undefined : contracts[0]
  const secondaryContract = contracts === undefined ? undefined : contracts[1]

  const tb = createTFunction('account:Accounting.', t)

  if (primaryContract?.status === ContractStatus.Active) {
    if (secondaryContract?.type && primaryContract?.type !== secondaryContract?.type) {
      return tb('SubscriptionDescPrepaidPayperclick')
    }
    switch (primaryContract?.type) {
      case ContractType.PayperClick:
        return tb('SubscriptionDescPayperclick')
      case ContractType.Prepaid:
        return tb('SubscriptionDescPrepaid')
      default:
        return tb('SubscriptionDescDefault')
    }
  }
  return tb('SubscriptionDescInactive')
}
